import { Store } from "@ngxs/store";
import { Injectable } from "@angular/core";
import { CanActivate } from "@angular/router";
import { Observable, of } from "rxjs";
import { AngularFireAuth } from "@angular/fire/compat/auth";
import { switchMap } from "rxjs/operators";
import { Navigate } from "@ngxs/router-plugin";

@Injectable({
  providedIn: "root",
})
export class NotLoggedInGuard implements CanActivate {
  constructor(private store: Store, private afAuth: AngularFireAuth) {}

  canActivate(): Observable<boolean> | Promise<boolean> | boolean {
    return this.afAuth.idTokenResult.pipe(
      switchMap((res) => {
        if (res) {
          this.store.dispatch(new Navigate(["/admin"]));
          return of(false);
        } else {
          return of(true);
        }
      })
    );
  }
}
